import { MenuItem, ProductChannel } from '@core/models';

export function getPrimaryProductChannel(
	item: MenuItem | null | undefined
): ProductChannel | undefined {
	return item?.productosCanal?.[0];
}
